import React from 'react';
import { Box, BoxProps } from '@mui/material';

interface Props extends BoxProps {
  value: React.ReactNode;
}

export const TemplateLtrOnly: React.FC<React.PropsWithChildren<Props>> = ({ value, ...rest }) => {
  return (
    <Box
      {...rest}
      dir={'ltr'}
      sx={[
        ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
        { ...rest?.style, textAlign: 'left' },
      ]}
    >
      {value}
    </Box>
  );
};
